import React, { Component} from 'react';
 
// import API from'../utilities/API'

import vid from '../../../../images/VoidOpen.mp4'
class vcStart extends Component {
  
  constructor(props) {
    super(props);
    this.handleLoop = this.handleLoop.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      usr: props.data.usr,      
      logo: props.data.logo,
      gamestate: props.data.gamestate,
      handleStateChange: props.data.handleStateChange,
      startcnt: 0
    }
    this.looppointer = {};    
    this.video = document.getElementsByTagName('opencheese')[0];
  }
  
componentDidMount(){
  this.looppointer = setInterval(this.handleLoop,1);


}  

handleLoop(){
  let cnt = this.state.startcnt;
  cnt ++
  if (cnt>10000){cnt=0}
  this.setState({startcnt: cnt})
  
}
closeMe(){
  clearInterval(this.looppointer);
  this.state.handleStateChange('game');
}
handleClick(event){
  this.closeMe();  
}  
   
    render() {
    
      return (
      <div className="container-fluid" onClick={(e)=>this.handleClick(e)}>
        
        {/* <div className="row justify-content-center">
        <div className="col-8"> */}
        <div className="d-flex justify-content-center">
        <video  onEnded={this.handleClick} id="opencheese" autoPlay>
          <source src={vid} type="video/mp4"/>
        </video>
        </div>  
        
        {/* </div>
        </div> */}
      </div>
              
           );            
              
  
      
    }  

  
}




export default vcStart; 


// WEBPACK FOOTER //
// ./src/components/Games/VoidCheddar/Pages/start.js